import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client";
import { apiErrorMessage } from "@/api/client";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await api.post("/auth/password-reset/request", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(apiErrorMessage(err, "送信に失敗しました。しばらくしてからお試しください。"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-semibold text-brand-700">かんたん在庫</h1>
          <p className="mt-2 text-sm text-gray-600">パスワード再設定</p>
        </div>

        {sent ? (
          <div className="card p-6 space-y-4">
            <h2 className="text-xl font-semibold">送信しました</h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              ご入力のメールアドレスがご登録済みの場合、パスワード再設定リンクを送信しました。
              メールが届かない場合は、迷惑メールフォルダもご確認ください。
            </p>
            <p className="text-xs text-gray-500">
              リンクの有効期限は <strong>3 日間</strong> です。
            </p>
            <div className="pt-3 border-t text-center">
              <Link to="/login" className="text-brand-700 font-medium hover:underline text-sm">
                ログイン画面へ戻る
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="card p-6 space-y-4">
            <h2 className="text-xl font-semibold">パスワードをお忘れの方</h2>
            <p className="text-sm text-gray-600">
              ご登録のメールアドレスを入力してください。再設定用のリンクをお送りします。
            </p>

            {error && (
              <div className="rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-800">
                {error}
              </div>
            )}

            <div>
              <label className="label" htmlFor="email">メールアドレス</label>
              <input
                id="email"
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                disabled={submitting}
              />
            </div>

            <button type="submit" className="btn-primary w-full" disabled={submitting}>
              {submitting ? "送信中..." : "再設定リンクを送信"}
            </button>

            <div className="pt-3 border-t text-center">
              <Link to="/login" className="text-brand-700 hover:underline text-sm">
                ログイン画面へ戻る
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
